import './ecommerceApp.module.less';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { renderRootElement } from '../common/init/renderMicroApp';
import mainCatchAllRoutes from '../main/mainCatchAllRoutes';
import ecommerceRoutes from './ecommerceRoutes';

const ecommerceRouter = createBrowserRouter([...ecommerceRoutes, ...mainCatchAllRoutes]);
renderRootElement(<RouterProvider router={ecommerceRouter} />);
